import React, { ComponentType } from 'react';
import { FixedLoadingSpinner } from '..';

type withSpinnerPropsType<T> = T & {
  loading: boolean;
  loadingContainerClassName?: string;
};

export const withFixedLoadingSpinner = <T extends object>(Component: ComponentType<T>) => {
  return ({ loading, loadingContainerClassName, ...componentProps }: withSpinnerPropsType<T>) => {
    if (loading) {
      return <FixedLoadingSpinner containerClassName={loadingContainerClassName} />;
    }

    return <Component {...(componentProps as T)} />;
  };
};